import * as angular from "angular";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";

angular
  .module('bringoz.admin.schedule')
  .factory('$scheduleTemplate', scheduleTemplateObjectFactory);

/* @ngInject */
function scheduleTemplateObjectFactory($bringozFactory: $bringozFactory,
                                       ScheduleTemplateAPI: BringozApi,
                                       ScheduleTemplates_DS: DataStoreConfig) {

  function $scheduleTemplate(id: string) {
    return $bringozFactory(id, ScheduleTemplateAPI, ScheduleTemplates_DS)
  }

  return $scheduleTemplate
}
